import { Chart } from "chart.js";

export const pieArrowLabelsPlugin = {
  id: "pieArrowLabels",
  afterDraw(chart) {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    const dataset = chart.data.datasets[0];

    const total = dataset.data.reduce(
      (sum: number, v: number) => sum + Number(v),
      0
    );

    ctx.save();
    ctx.font = "600 4rem";
    ctx.fillStyle = "#ffffff";
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 1;

    meta.data.forEach((arc: any, i: number) => {
      const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
      const angle = (startAngle + endAngle) / 2;

      // Start INSIDE the slice (closer to center)
      const startRadius =
        innerRadius + (outerRadius - innerRadius) * 0.75;

      const x1 = x + Math.cos(angle) * startRadius;
      const y1 = y + Math.sin(angle) * startRadius;

      // End OUTSIDE the pie
      const x2 = x + Math.cos(angle) * (outerRadius + 24);
      const y2 = y + Math.sin(angle) * (outerRadius + 24);

      // Draw line
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();

      // Percentage only
      const value = Number(dataset.data[i] ?? 0);
      const percent = total > 0 ? Math.round((value / total) * 100) : 0;

      ctx.textAlign = Math.cos(angle) > 0 ? "left" : "right";
      ctx.textBaseline = "middle";
      ctx.fillText(`${percent}%`, x2, y2);
    });


    ctx.restore();
  },
};
